































































































































































































































































































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {DeditForm} from "@/form/DeviceForm";
import deviceModule from '@/store/module/DeviceModule';
import CreateDialog from "@/component/Crud/create-dialog.vue";
import EditDialog from "@/component/Crud/edit-dialog.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import {Container} from "typescript-ioc";
import {DeviceDetail} from "@/model/Device";
import UserApi from "@/module/user/UserApi";
import User from '@/model/User';
import {DefaultRoleKey} from "@/model/Role";
import _ from 'lodash';
import VueQrcode from 'vue-qrcode';
import RefreshButton from "@/component/Button/refresh-button.vue";
import ProductUtil from "@/module/device/ProductUtil";
import ConfirmDialog from "@/component/Dialog/confirm-dialog.vue";
import DeviceUpgradeInfo from "@/module/device/DeviceUpgradeInfo";
import DeviceShareApi from "@/module/device/DeviceShareApi";
import DeviceSharecode from "@/view/device-manage/device/sharecode.vue";
import {handleClipboard} from "@/util/clipboard";
import DeviceApi from "@/module/device/DeviceApi";

@Component({
  components: {
    ConfirmDialog,
    CreateDialog,
    EditDialog,
    DeleteDialog,
    VueQrcode,
    RefreshButton,
    DeviceSharecode,
  },
})
export default class DeviceInfoView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private shareApi = Container.get(DeviceShareApi)

  private userApi = Container.get(UserApi)

  @Ref()
  private editDialog!: EditDialog

  private deviceModule = deviceModule

  private deviceId = this.$route.query.did as unknown as number

  private device = new DeviceDetail()

  private editForm: DeditForm = {
    id: -1,
    name: "",
    alias: "",
  }

  private users: Array<User> = []
  private bindUserId = -1

  private get qrcode() {
    return ProductUtil.qrcode(this.device.product.key, this.device.product.natureKey, this.device.activeCode)
  }

  @Ref()
  private bindDialog!: CreateDialog

  @Ref()
  private unbindDialog!: DeleteDialog

  @Ref()
  private baqDialog!: CreateDialog

  private beforeOpenEditDialog() {
    this.editForm.id = deviceModule.active.id
    this.editForm.name = deviceModule.active.name
    this.editForm.alias = deviceModule.active.alias
  }

  private async editDevice() {
    await this.deviceApi.edit(this.editForm)
    await this.getDeviceDetail()
    this.$bus.$emit('device:update')
  }

  private async created() {
    await this.getDeviceDetail()
  }

  private refresh() {
    this.getDeviceDetail()
  }

  private async getDeviceDetail() {
    this.device = await this.deviceApi.detail(this.deviceId)
    await deviceModule.activate(this.device)
  }

  private openBindDialog() {
    this.getUsers()
    this.bindDialog.open()
  }

  private openBaqDialog() {
    this.getUsers()
    this.baqDialog.open()
  }

  private async getUsers() {
    this.users = await this.userApi.list(DefaultRoleKey.ROLE_USER)
    if (!_.isEmpty(this.users))
      this.bindUserId = this.users[0].id
  }

  private async bind() {
    await this.deviceApi.bind({
      id: this.device.id,
      userId: this.bindUserId
    })
    this.$bus.$emit('device:update')
  }

  private async baq() {
    await this.deviceApi.baq({
      activeCode: this.device.activeCode,
      mac: this.device.mac,
      userId: this.bindUserId
    })
    this.$bus.$emit('device:update')
  }

  private async unbind() {
    await this.deviceApi.unbind(this.device.id)
    this.$bus.$emit('device:update')
  }

  @Ref()
  private upgradeDialog!: ConfirmDialog

  private upgradeInfo = new DeviceUpgradeInfo()

  private version = 2

  private async openUpgradeDialog() {
    this.upgradeInfo = await this.deviceApi.detectUpgrade(this.device.id)
    this.upgradeDialog.open()
  }

  private async upgrade() {
    const deviceId = this.device.id
    let topic: string | undefined = undefined
    if (this.version == 1)
      topic = `s/${deviceId}`
    await this.deviceApi.upgrade(deviceId, topic)
  }

  private copy = handleClipboard
}
